module.exports = __webpack_public_path__ + "static/img/alt.756d8dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alt.png
// module id = 8R+n
// module chunks = 1